import { Grid, Typography } from "@material-ui/core";
import React from "react";

//Update log
// FB 4867 DK   12/27/2021    Added to display closure message
//

export default function FinalPage(props: any) {
  let origin: string = props.location.state.origin;
  return (
    <div>
      <section
        style={{
          margin: "10px 20px 20px",
        }}
      >
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "2%",
            }}
          >
            <Typography variant={window.innerWidth < 768 ? "subtitle1" : "h5"}>
              {origin === "upload" ? "Please close this tab to continue." : "Thank you for booking an appointment with us. Have a great day!"}
            </Typography>
          </Grid>
        </Grid>
      </section>
    </div>
  )
}